import React, { Fragment, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { NavLink, withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions';
import gapLogo from '../../assets/gap_logo_login.png';
import geequipCover from '../../assets/geequip_image_login.png';
import geequipLogo from '../../assets/geeequip_logo_login.png';
import loginBackground from '../../assets/background_login.png';
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Button,
  TextField,
  Grid,
  IconButton,
  Box,
  FormControl,
  useMediaQuery,
  useTheme,
  InputAdornment
} from '@mui/material';
import { i18n } from '../../translate/i18n';
import LanguageSelection from './components/LanguageSelection';
import SpinnerOverlay from '../../UI/SpinnerOverlay/SpinnerOverlay';

type Props = {
  history: any
}

const Login = (props: Props) => {
  const dispatch: any = useDispatch();

  const theme = useTheme();
  const largeScreen = useMediaQuery(theme.breakpoints.up('sm'));

  const [noAccess, setNoAccess] = useState(false)
  const [showError, setShowError] = useState(false)
  const [showErrorPassword, setShowErrorPassword] = useState(false)
  const [showErrorManyRequests, setShowErrorManyRequests] = useState(false)
  const [showErrorConnection, setShowErrorConnection] = useState(false)
  const [showPassword, setShowPassword] = useState(false);

  const [form, setForm] = useState({ email: '', password: '' })

  const loading = useSelector((state: any) => state.auth.loading);

  useEffect(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('selectedTenant');
  }, [])

  const changeValue = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;

    setForm({
      ...form,
      [name]: value
    });
    setShowError(false);
    setShowErrorPassword(false)
    setShowErrorManyRequests(false)
    setShowErrorConnection(false);
  }

  const submit = async (event: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLDivElement>) => {
    event.preventDefault();
    setShowError(false);
    setShowErrorPassword(false)
    setShowErrorManyRequests(false)
    setShowErrorConnection(false);
    setNoAccess(false);

    dispatch(actions.auth(form.email, form.password)).then((res: any) => {
      if (res.access.length > 1 || res.superadmin) {
        props.history.push('/tenantselecao');
      } else {
        if (res.access && res.access.length > 0 && res.access[0].active === false) {
          props.history.push('/tenantselecao');
        } else if (!res.access || res.access.length === 0) {
          setNoAccess(true);
        } else {
          const redirectTo = localStorage.getItem('redirectTo');
          if (redirectTo) {
            localStorage.removeItem('redirectTo');
            return props.history.push(redirectTo);
          }
          props.history.push('/');
        }
      }
    }).catch((error: any) => {
      if (error.response) {
        if (error.response.status === 401) {
          setShowErrorPassword(true)
        } else if (error.response.status === 429) {
          setShowErrorManyRequests(true)
        }  else {
          setShowError(true)
        }
      } else {
        setShowErrorConnection(true)
      }
    })
  }

  return (
    <>
      <Helmet>
        <title>Área do Cliente GEEQUIP | Acesso Restrito</title>
        <meta name="description" content="Acesso exclusivo para clientes da GAP que utilizam o ambiente GEEQUIP. Entre com suas credenciais para acessar a plataforma." />
      </Helmet>
      <Grid container sx={{ ...styles.container, backgroundImage: !largeScreen ? `url(${loginBackground})` : 'initial' }}>
        <Grid item xl={6} md={7} sm={7} xs={12} sx={{ px: '7%'}} order={{ xs: 2, sm: 1 }}>
          <Box sx={styles.loginContainer}>
            <FormControl sx={styles.loginForm}>
              <img src={geequipLogo} style={styles.geequipLogo} alt="GEEQUIP - Gestão de Equipamentos"/>
              <h1 style={styles.srOnly}>Acesso à área do cliente</h1>
              {loading &&
                <Box sx={styles.loadingContainer}>
                  <SpinnerOverlay />
                </Box>
              }
              <TextField
                variant="outlined"
                placeholder='email@email.com.br'
                margin="normal"
                required
                fullWidth
                id="email"
                label={i18n.t('textFieldLogin1.email') as string}
                name="email"
                autoComplete="email"
                autoFocus
                onChange={changeValue}
                value={form.email}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    submit(e);
                  }
                }}
              />
              <TextField
                variant="outlined"
                placeholder='*******'
                margin="normal"
                required
                fullWidth
                name="password"
                label={i18n.t('textFieldLogin1.password') as string}
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                onChange={changeValue}
                value={form.password}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    submit(e);
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onMouseUp={() => setShowPassword(!showPassword)}
                        onMouseDown={() => setShowPassword(!showPassword)}
                        style={{ paddingRight: 8 }}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />

              {showError && <Box sx={styles.errorText}>{i18n.t('divLogin.showError') as string}</Box>}
              {showErrorConnection && <Box sx={styles.errorText}>{i18n.t('divLogin.showErrorConnection') as string}</Box>}
              {showErrorManyRequests && <Box sx={styles.errorText}>{i18n.t('divLogin.showErrorManyRequests') as string}</Box>}
              {showErrorPassword && <Box sx={styles.errorText}>{i18n.t('divLogin.showErrorPassword') as string}</Box>}
              {noAccess && <Box sx={styles.errorText}>{i18n.t('divLogin.noAccess') as string}</Box>}

              <NavLink style={styles.link} to='/forgotpassword'>
                {i18n.t('navLinkStyledLogin.text') as string}
              </NavLink>
              <Button
                fullWidth
                variant="contained"
                onClick={submit}
                disabled={loading}
                sx={{ ...styles.buttonSubmit, margin: theme.spacing(3, 0, 2) }}
              >
                Sign In
              </Button>
              <img src={gapLogo} style={styles.gapLogo}/>
            </FormControl>
            { !largeScreen && <Box sx={{ my: '10%' }}><LanguageSelection sx={{ position: 'relative' }} /></Box> }
          </Box>
        </Grid>
        <Grid item xl={6} md={5} sm={5} xs={12} order={{ xs: 1, md: 2 }} sx={{ height: largeScreen ? '100%' : 'auto' }}>
          { largeScreen &&
            <Fragment>
              <LanguageSelection />
              <img src={geequipCover} style={{...styles.coverImage, objectFit: 'cover'}} />
            </Fragment> 
          }
        </Grid>
      </Grid>
    </>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundSize: 'cover'
  },
  loginContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  loginForm: {
    width: '100%',
    maxWidth: '380px',
    mt: 1,
    position: 'relative'
  },
  geequipLogo: {
    width: '11rem',
    height: '5rem'
  },
  loadingContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    bgcolor: '#fff',
    opacity: '0.5',
    zIndex: 2
  },
  errorText: {
    color: 'red'
  },
  link: {
    margin: '1.5rem 0',
    textDecoration: 'none',
    color: 'primary',
    display: 'flex',
    alignSelf: 'flex-end',
  },
  buttonSubmit: {
    color: '#fff',
    backgroundColor: 'green',
    '&:hover': {
      backgroundColor: 'green',
      opacity: .90,
    },
  },
  gapLogo: {
    width: '6rem',
    height: '3rem',
    display: 'flex',
    alignSelf: 'center'
  },
  coverImage: {
    width: '100%',
    height: '100%',
    objectPosition: 'center'
  },
  srOnly: {
    position: 'absolute' as const,
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap' as const,
    border: 0
  }
};

export default withRouter(Login)
